<template>
  <ConfigLayout current="staff">
    <ConfigPage title="スタッフ設定">
      <template slot="header">
        <Button flat :disabled="editDisabled" @click="$router.push({ name: 'staffOrder' })">
          <MoveIcon />並べ替え
        </Button>
        <Separator />
        <Button flat :disabled="allStaffs.length >= 20" @click="showEdit"><AddStrongIcon />新規</Button>
      </template>
      <DataTable
        :data="allStaffs"
        :columns="[{ key: 'name', name: 'スタッフ名' }]"
        :minItemHeight="56"
        :loading="busy"
        nodata="スタッフが登録されていません"
        editButton
        @edit="showEdit"
        :deleteButton="!editDisabled"
        @delete="onDelete"
      >
      </DataTable>
      <StaffEditModal v-if="staffEditModal" @saved="fetch" @close="staffEditModal = false" />
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import Button from '@/components/atoms/Button'
import { Separator } from '@/components/molecules/PageHeader'
import DataTable from '@/components/molecules/DataTable'
import Dialog from '@/components/molecules/ModalDialog'
import StaffEditModal from '@/components/organisms/StaffEditModal'
import AddStrongIcon from '@/components/icons/addStrong'
import MoveIcon from '@/components/icons/move'

export default {
  name: 'Options',
  components: {
    ConfigLayout,
    ConfigPage,
    Button,
    Separator,
    DataTable,
    StaffEditModal,
    AddStrongIcon,
    MoveIcon,
  },
  data() {
    return {
      staffEditModal: false,
    }
  },
  computed: {
    ...mapState({
      busy: state => state.staffs.busy,
    }),
    ...mapGetters({
      allStaffs: 'staffs/all',
    }),
    editDisabled() {
      return this.allStaffs.length < 2
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('staffs/get')
    },
    async onDelete({ id, name }) {
      if (
        (await Dialog.confirm({
          title: 'スタッフ削除',
          message: '以下のスタッフ登録を削除してよろしいですか？',
          target: name,
          caution: true,
          cancelText: '戻る',
          okText: '削除',
        })) &&
        (await this.$store.dispatch('staffs/delete', id))
      ) {
        this.fetch()
      }
    },
    showEdit({ id } = {}) {
      this.$store.dispatch('staffs/edit/start', id)
      this.staffEditModal = true
    },
  },
}
</script>
